import request from '@/utils/request'


// 查询直播签到列表
export function listLiveSign(query) {
  return request({
    url: '/live/live/sign/list',
    method: 'get',
    params: query
  })
}

// 查询直播签到分页
export function pageLiveSign(query) {
  return request({
    url: '/live/live/sign/page',
    method: 'get',
    params: query
  })
}

// 查询直播签到详细
export function getLiveSign(data) {
  return request({
    url: '/live/live/sign/detail',
    method: 'get',
    params: data
  })
}

// 新增直播签到
export function addLiveSign(data) {
  return request({
    url: '/live/live/sign/add',
    method: 'post',
    data: data
  })
}

// 修改直播签到
export function updateLiveSign(data) {
  return request({
    url: '/live/live/sign/edit',
    method: 'post',
    data: data
  })
}

// 删除直播签到
export function delLiveSign(data) {
  return request({
    url: '/live/live/sign/delete',
    method: 'post',
    data: data
  })
}
